import { sortArraysByKey } from 'store/features/projectData/utils'
import {
  IAiVideoModel,
  IAiVideoModelOption,
  IPromptAnalyzerResponse,
  IVideo
} from './interfaces'

export const createNewVideo = (
  defaultStyleId: number = 0,
  defaultModel: string | undefined = 'forest-1.0'
): IVideo => ({
  id: `video-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
  mode: 'animated',
  generateVideoBody: {
    prompt: '',
    styleId: defaultStyleId,
    isVoiceOverDisabled: false,
    model: defaultModel
  }
})

const getVideoModelMinDuration = (
  options: IAiVideoModelOption[] | undefined
) => (options ? sortArraysByKey('durationSeconds', options)[0] : undefined)

const genAiActiveVideoModelId = (
  aiVideoModels: IAiVideoModel[],
  genAiPromptAnalyzerVideoModel: string
) =>
  aiVideoModels?.find(
    model =>
      model.code === genAiPromptAnalyzerVideoModel ||
      model.model === genAiPromptAnalyzerVideoModel
  )?.id || 0

const genAiActiveVideoModelCode = (
  genAiActiveVideoModelId: number,
  aiVideoModels: IAiVideoModel[]
) => aiVideoModels?.find(model => model.id === genAiActiveVideoModelId)?.code

const genAiVideoModelMinDurationData = (
  videoModelCode: string | undefined,
  videoModels: IAiVideoModel[]
) => {
  const videoModelOptions = videoModels?.find(
    model => model.code === videoModelCode || model.model === videoModelCode
  )?.options
  return getVideoModelMinDuration(videoModelOptions)?.durationSeconds || 1
}

export const getScenesCount = (
  models: IAiVideoModel[],
  analyzePromptResponse: IPromptAnalyzerResponse
) => {
  const aiActiveVideoModelId = genAiActiveVideoModelId(
    models,
    analyzePromptResponse.videoModel
  )
  const aiActiveVideoModelCode = genAiActiveVideoModelCode(
    aiActiveVideoModelId,
    models
  )
  const durationPerScene = genAiVideoModelMinDurationData(
    aiActiveVideoModelCode,
    models
  )

  return Math.ceil(analyzePromptResponse.duration / durationPerScene)
}
